@if (displayWarning()) {
<div class="warning">{{ 'aichat.chat.prompt_bar.warning' | translate }}</div>
}
<div class="input-area">
    @if (attachmentChips().length > 0) {
    <div class="chips">
        @for (chip of attachmentChips(); track chip.id) {
        <p-attachment-preview
            [icon]="chip.icon"
            [label]="chip.label"
            [detail]="chip.detail"
            [removeLabel]="'aichat.attach.remove' | translate"
            (removeClicked)="removeChip(chip.id)"
        ></p-attachment-preview>
        }
    </div>
    } @if (fileToUpload(); as file) {
    <p-attachment-preview
        class="file-preview-container"
        [file]="file"
        [removeLabel]="'aichat.attach.remove_file' | translate"
        (removeClicked)="removeFile()"
    ></p-attachment-preview>
    }
    <div class="input-actions">
        @if (showFileUpload()) {
        <p-file-upload-button class="file-upload-button" (fileSelected)="onFileSelected($event)"> </p-file-upload-button>
        } @if (showSourcesMenu()) {
        <input
            #fileInput
            type="file"
            class="file-input"
            [accept]="fileAccept()"
            [multiple]="fileMultiple()"
            (change)="onFilesChosen(fileInput)"
        />
        <p-ai-chat-attachment-sources-menu
            [sources]="allowedSources()"
            [disabled]="disabled()"
            (sourceSelected)="onSourceSelected($event, fileInput)"
        ></p-ai-chat-attachment-sources-menu>
        }
        <p-field-text
            class="prompt-p-field-text"
            [placeholder]="'aichat.chat.prompt_bar.placeholder' | translate"
            [ngModel]="input()"
            (ngModelChange)="onInputChanged($event)"
            (keydown.enter)="$event.preventDefault()"
            (enterPressed)="onEnterPressed($event)"
            [autoFocus]="true"
            [isDisabled]="disabled()"
            [isMultiline]="true"
            [size]="inputSize"
            [isExpandable]="true"
            [autoSizeMinRows]="1"
            [autoSizeMaxRows]="4"
        ></p-field-text>

        @if (showStopButton()) {
        <p-action-button
            #stopBtn
            class="stop-button"
            (buttonClicked)="stopBtn.isActive = true; triggerInterrupt()"
            iconBeforeName="stop-circle"
            iconBeforeSize="sm"
            iconBeforeColor="functional-default"
            [disabled]="disabled()"
        ></p-action-button>
        } @if (disabled() || !disabledSubmit()) {
        <p-action-button
            class="submit-button"
            (buttonClicked)="triggerPrompt()"
            iconBeforeName="send"
            iconBeforeSize="sm"
            [disabled]="!canSubmit()"
        ></p-action-button>
        }
    </div>
</div>
